import { render, staticRenderFns } from "./ListingLogo.vue?vue&type=template&id=20a55382&scoped=true&"
import script from "./ListingLogo.vue?vue&type=script&lang=js&"
export * from "./ListingLogo.vue?vue&type=script&lang=js&"
import style0 from "./ListingLogo.vue?vue&type=style&index=0&id=20a55382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a55382",
  null
  
)

export default component.exports